<template>
  <div class="row mt-3">
    <div class="col-12">
      <div class="d-flex flex-row justify-content-start align-items-center">
        <!-- <h3 :class="`header-color-${confidence}`">{{ profileScore || 0 }}%</h3> -->
        <!-- Uncomment below and remove below after report -->
        <h3 :class="`header-color-${confidence}`">{{ wellnessScore || 0 }}%</h3>
        <div>
          <span class="badge rounded-pill bg-darker ms-2 text-uppercase text-xs"
            :class="`header-color-${confidence}`">{{ confidence }} confidence</span>
        </div>
      </div>
    </div>
  </div>
  <div v-if="displayDna && false" class="row aggregated-row mt-2">
    <div class="col-10">DNA Score</div>
    <div v-if="dnaScore > 0" class="col-2 text-nowrap text-end">{{ dnaScore || 0 }}%</div>
    <div v-else class="col-2 text-nowrap text-end">- -</div>
  </div>
  <div v-if="displayDna && false">
    <div v-for="gc in geneticContributions" :key="gc.dna_category.dna_category_id"
      class="row contribution-row mt-2 text-sm">
      <div class="col-10">{{ gc.dna_category.dna_category_name }}</div>
      <div class="col-2 text-nowrap text-end">{{ gc.score || 0 }}%</div>
    </div>
  </div>

  <div class="row aggregated-row mt-4">
    <div class="col-10">Wellness Score</div>
    <div v-if="wellnessScore > 0" class="col-2 text-nowrap text-end">{{ wellnessScore || 0 }}%</div>
    <div v-else class="col-2 text-nowrap text-end">- -</div>
  </div>
  <div v-for="wc in wellnessContributions" :key="wc.factor_id" class="row contribution-row mt-2 text-sm">
    <div class="col-10">{{ wc.factor_name }}</div>
    <div class="col-2 text-nowrap text-end">{{ wc.contribution_percentage || 0 }}%</div>
  </div>
  <div v-if="wellnessReport">
    <div v-if="wellnessReport.summary || wellnessReport.wellnessScore" class="summary-details">
      <div class="left-rail" aria-hidden="true"></div>
      <div class="content">
        <p class="text"> <b> {{ wellnessReport.wellnessScore.status }} </b> {{ wellnessReport.summary }} </p>
      </div>
    </div>

    <div v-if="wellnessReport.focusAreas && wellnessReport.focusAreas.length > 0" class="mt-4">
      <h5 class="text-muted" style="padding-left: 0.5rem !important;">Focus Areas</h5>
      <div class="contribution-row mt-2 focus-area" v-for="(area, index) in wellnessReport.focusAreas" :key="index">
        <div class="col-12" style="color:white">{{ area.name }} - {{ area.details }}</div>
        <div class="col-12 text-sm mt-1 p-1"><b class="aggregated-row">Issue:</b> 
        <p class="contribution-row">{{area.issue }}</p></div>
        <div class="col-12 text-sm mt-1 p-1"><b class="aggregated-row">Recommendation:</b>
          <p class="contribution-row">{{ area.recommendation }}</p></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    confidence: {
      type: String,
      default: "low",
    },
    dnaScore: {
      type: Number,
      default: 0,
    },
    wellnessScore: {
      type: Number,
      default: 0,
    },
    profileScore: {
      type: Number,
      default: 0,
    },
    geneticContributions: {
      type: Array,
    },
    wellnessContributions: {
      type: Array,
    },
    displayDna: {
      type: Boolean,
      required: true,
    },
    wellnessReport: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
  },
  mounted() {
    // Extract wellness information from the report when the component is mounted
    console.log('Mounted UserProfileContributions with wellnessReport:', this.wellnessReport);
  },
  methods: {
  },
  watch: {
    geneticContributions() {
    },
    wellnessContributions() {
    },
    profileScore() {
    },
    wellnessScore() {
    },
    wellnessReport() {
      console.log('wellnessReport changed:', this.wellnessReport);
    },
  },
};
</script>

<style lang="scss" scoped>
.aggregated-row {
  color: $color-aggregated-score;
  font-weight: 700;
}

.contribution-row {
  color: $color-contribution-score;
}

.focus-area {
  background: #061d23;
  padding: 0.5rem;
  border-radius: 0.5rem;
}

.left-rail {
  background: linear-gradient(180deg, rgba(0, 255, 209, 0.9), rgba(0, 255, 209, 0.45));
}

.content {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0.85rem 1rem;
}

.text {
  margin: 0;
  font-size: 1rem;
  letter-spacing: 0.2px;
  color: rgba(160, 255, 230, 0.75);
  line-height: 1.35;
}

.summary-details {
  margin-top: 1rem;
  width: 100%;
  background: rgba(24, 26, 28, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 0.5rem;
  overflow: hidden;
  display: grid;
  grid-template-columns: 0.5rem 1fr;
  box-shadow: 0 0.7rem 2rem rgba(0, 0, 0, 0.35);
}
</style>
